var app = angular.module("leonardo");

var SSOCallbackController = function($scope, deviceDetector, $location, $timeout) {
    $scope.redirectFailed = false;
    $scope.isLoading = true;
    let redirectAttempted = false;
    let redirectTimeout;

    $scope.tryRedirect = function() {
        let sessionId = $location.search().session_id;
        let url = deviceDetector.os === 'android' ? 'leonardo://login' : 'com.webpartners.leonardo://login';
        redirectAttempted = true;
        if (redirectTimeout) {
            $timeout.cancel(redirectTimeout);
        }
        // Try to redirect
        let redirectUrl = sessionId ? `${url}?sessionId=${sessionId}` : url;
        window.location.replace(redirectUrl);
        
        redirectTimeout = $timeout(function() {
            if (!document.hidden && redirectAttempted) {
                $scope.redirectFailed = true;
                $scope.isLoading = false;
            }
        }, 3000);
    };

    $scope.redirectToMobile = function() {
        $scope.isLoading = true;
        $scope.redirectFailed = false;
        redirectAttempted = false;
        $scope.tryRedirect();
    };
    $timeout(function() {
        if(deviceDetector.isMobile() || deviceDetector.isTablet()){
            $scope.tryRedirect();
        }
    }, 1000);
};

app.controller("SSOCallbackController", ["$scope", 'deviceDetector', '$location', '$timeout', SSOCallbackController]);